<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container *ngIf="mode === 'nohomesmall' else mbfilters">
        {{zielText}}
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100 tmp-bottom-right" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24"
            width="24px" fill="#000000">
            <g>
                <rect fill="none" height="24" width="24" />
            </g>
            <g>
                <g />
                <g>
                    <g>
                        <path fill="#7c7c7d"
                            d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3 C23,14.82,19.43,13.53,16.67,13.13z"
                            fill-rule="evenodd" />
                    </g>
                    <g>
                        <circle fill="#7c7c7d" cx="9" cy="8" fill-rule="evenodd" r="4" />
                    </g>
                    <g>
                        <path fill="#7c7c7d"
                            d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z"
                            fill-rule="evenodd" />
                    </g>
                    <g>
                        <path fill="#7c7c7d" d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z"
                            fill-rule="evenodd" />
                    </g>
                </g>
            </g>
        </svg>
        <span multilang class="ellipsis" style="color: #7c7c7d;">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homemodeMobile>
    <button class="tmpbtn w100 tmp-bottom-right" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24"
            width="24px" fill="#000000">
            <g>
                <rect fill="none" height="24" width="24" />
            </g>
            <g>
                <g />
                <g>
                    <g>
                        <path fill="#7c7c7d"
                            d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3 C23,14.82,19.43,13.53,16.67,13.13z"
                            fill-rule="evenodd" />
                    </g>
                    <g>
                        <circle fill="#7c7c7d" cx="9" cy="8" fill-rule="evenodd" r="4" />
                    </g>
                    <g>
                        <path fill="#7c7c7d"
                            d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z"
                            fill-rule="evenodd" />
                    </g>
                    <g>
                        <path fill="#7c7c7d" d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z"
                            fill-rule="evenodd" />
                    </g>
                </g>
            </g>
        </svg>
        <span multilang class="ellipsis" style="color: #7c7c7d;">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn w100" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModal($event)" matRipple>
        <!-- <mat-icon fontIcon="people_alt"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24"
            width="24px" fill="#000000">
            <g>
                <rect fill="none" height="24" width="24" />
            </g>
            <g>
                <g />
                <g>
                    <g>
                        <path fill="#7c7c7d"
                            d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3 C23,14.82,19.43,13.53,16.67,13.13z"
                            fill-rule="evenodd" />
                    </g>
                    <g>
                        <circle fill="#7c7c7d" cx="9" cy="8" fill-rule="evenodd" r="4" />
                    </g>
                    <g>
                        <path fill="#7c7c7d"
                            d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z"
                            fill-rule="evenodd" />
                    </g>
                    <g>
                        <path fill="#7c7c7d" d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z"
                            fill-rule="evenodd" />
                    </g>
                </g>
            </g>
        </svg>
        <span multilang class="ellipsis" style="color: #7c7c7d;">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <span multilang class="title noselect">{{'Reiseteilnehmer'}}</span>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <span multilang class="title mleft noselect">{{'Reiseteilnehmer'}}</span>
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">close</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <div class="r-wrapper">
            <div class="rowitem">
                <span multilang class="r-title noselect">{{'Erwachsene'}}</span>
                <div class="rb-wrapper">
                    <button class="btnremove" (click)="removeAdult()" [class.disablebtn]="nbAdult === 1" matRipple>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <span multilang class="r-count noselect">{{nbAdult}}</span>
                    <button class="btnadd" (click)="addAdult()" [class.disablebtn]="nbAdult === 8" matRipple>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
            <div class="rowitem">
                <span multilang class="r-title noselect">{{'Kinder'}}</span>
                <div class="rb-wrapper">
                    <button class="btnremove" (click)="removeChildrent()" [class.disablebtn]="nbChildren === 0"
                        matRipple>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <span multilang class="r-count noselect">{{nbChildren}}</span>
                    <button class="btnadd" (click)="addChildren()" [class.disablebtn]="nbChildren === 8" matRipple>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-wrapper">
            <ng-container *ngIf="nbChildren > 0" [ngTemplateOutlet]="childrens"></ng-container>
        </div>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn cancelbtn" (click)="closeModal()" multilang>{{'Zuruck'}}</button>
        <button class="ubbtn noselect" (click)="selected()" multilang>{{'ÜBERNEHMEN'}}</button>
    </div>
</ng-template>

<ng-template #childrens>
    <div class="c-t-wrapper">
        <span multilang>{{'Bitte geben Sie das Alter Ihres Kindes an'}}.</span>
    </div>
    <div class="r-wrapper">
        <ng-container *ngFor=" let ch of childrenList">
            <div class="c-list-wrapper">
                <div class="c-name">
                    <span multilang class="r-title noselect">{{ch.name}}</span>
                    <span multilang class="r-title-second">{{'Alter in Jahren'}}</span>
                </div>
                <div class="rb-wrapper">
                    <button class="btnremove" (click)="removeChildrentAge(ch)" [class.disablebtn]="ch.age === 0"
                        matRipple>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <select class="c-select" [(ngModel)]="ch.age">
                        <option value="0" multilang>Alter</option>
                        <option value="1">{{"<2"}} </option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                    </select>
                    <button class="btnadd" (click)="addChildrenAge(ch)" [class.disablebtn]="nbChildren === 17"
                        matRipple>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>